var map = {
	"./sponsor-1.png": "95ac",
	"./sponsor-2.png": "288f",
	"./sponsor-3.png": "3516",
	"./sponsor-4.png": "e35c",
	"./sponsor-5.png": "b07b",
	"./sponsor-6.png": "fc69",
	"./sponsor-7.png": "32d5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f15";